<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/4NgyBi/tc-custom/9781466853171.jpg?1737196285749" alt="This image is the cover for the book Your Father's Voice"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Your Father's Voice
      </h1>
      <p class="bookDescription body article font2">
        <p>It seemed like just plain bad luck. On September 11, 2001, Jeremy Glick boarded United Flight 93 only because a fire at Newark Airport had prevented him from flying out the day before. That morning, he called his wife, Lyz, to tell her the plane had been hijacked and that he and a group of others were going to storm the cockpit, an effort that doomed Glick and his fellow passengers yet doubtless saved lives on the ground and instantly became known worldwide as a heroic moment of resistance. But Lyz wanted the couple's daughter, Emmy, only three months old when the plane crashed, to learn much more of her father's story than just the ending. <i>Your Father's Voice</i> narrates Lyz's struggle to come to grips with her husband's death in a series of letters from Lyz to Emmy that give a wrenching but clear-eyed account of Lyz's first years without Jeremy. The letters also portray the rebellious but charismatic star athlete who became Lyz's high school sweetheart, a national collegiate judo champion, and finally her husband. We see Lyz's medical ordeal as she tries to bring Emmy into the world, Jeremy's tender nurturing of the premature baby, and the agony of his final telephone call from the ill-fated plane.<br/><br/>But it is during the first frantic months after the terrorist attack---as she fends off the media and fights to get the truth about what happened on Flight 93---that Lyz realizes that she and Jeremy are still deeply connected, that his love for her and Emmy endures and teaches. Soon Lyz can write to Emmy that she believes it was destiny, not luck, that put a world-class martial artist like Jeremy on an airplane with other men and women who were also determined to fight back.<br/><br/>Through it all, Lyz pragmatically details the challenges of a single parent raising a daughter in the aftermath of horrific tragedy, and urges Emmy to listen for what Lyz can still hear when the wind is right: her father's voice.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lyz Glick, Dan Zegart
      </h2>
      
      <p class="authorDescription body article"><P><B>Lyz Glick</B> is the widow of Jeremy Glick, a former national collegiate judo champion who helped attack the cockpit of Flight 93 on September 11, 2001. She teaches at Berkeley College in New Jersey, and she and Emmy live in Hewitt, New Jersey.<br><br><B>Dan Zegart</B>, a longtime journalist who has written for <I>Ms.</I> and <I>The Nation</I>, is the author of <I>Civil Warriors: The Legal Siege on the Tobacco Industry</I>. He lives in Titusville, New Jersey, with his wife, photographer Laura Pedrick, and their daughter, Lana.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Griffin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b7e97730